var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content content"},[_c('div',{staticClass:"content-overlay"}),_c('div',{staticClass:"header-navbar-shadow"}),_c('div',{staticClass:"content-wrapper pb-1"},[_c('section',{attrs:{"id":"card-navigation modern-horizontal-wizard"}},[_c('div',{staticStyle:{"font-weight":"bold","text-align":"center"}},[_vm._v("404 Page Not Found")])])])])
}]

export { render, staticRenderFns }